import { render, staticRenderFns } from "./SearchBoxDefault.vue?vue&type=template&id=658e2a5e"
import script from "./SearchBoxDefault.vue?vue&type=script&lang=js"
export * from "./SearchBoxDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports